<template>
  <div class="pagefoot">
    <ul  v-if="PolicyList">
      <li
        v-for="item in PolicyList"
        :key="item['slug']"
        data-toggle="modal"
        data-target="#PolicyPagesleModal"
        @click="getPolicy(item['slug'])"
      >
        {{$t(`policy.${item["slug"]}`) }}
      </li>
    </ul>
    <div
      class="modal fade"
      id="PolicyPagesleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="PolicyPagesleModal"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              v-if="currentPolicy && PolicyList && PolicyList[currentPolicy]"
            >
              {{$t(`policy.${PolicyList[currentPolicy]["slug"]}`)}}
            </h5>
          </div>
          <div
            class="modal-body"
            v-if="currentPolicy && PolicyList && PolicyList[currentPolicy]"
            v-html="PolicyList[currentPolicy]['content']"
          ></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary checkout_btn_color"
              data-dismiss="modal"
              style="background-color:#0f88a7;border:none"
            >
               {{$t('comment.ok')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="show_copyright">{{ $t("shopping.all_rights_reserved") }} {{ blogname }}</div>
    <div v-if="custom_text" v-html="custom_text"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// import API from "../../../API";
export default {
  props: ["blogname", "PolicyPages"],
  data() {
    return {
      PolicyList: {},
      currentPolicy: null,
    };
  },
  computed: {
    ...mapState({
      custom_text: ({ options }) => {
        let custom_text = false;
        let config = options?.theme?.pages?.checkout?.config;
        if(config && config.custom_text_on && config.custom_text){
          custom_text = config.custom_text;
        }
        return custom_text;
      },
    }),
  },
  methods: {
    async getPolicy(slug) {
      this.currentPolicy = slug;
      if (!this.PolicyList[slug]["content"]) {
        try {
          let res = await this.$axios.get(`${API.getPolicy}/${slug}`, {
            headers: {
              accept: "application/json",
            },
          });
          if (res && res.data && res.data.content) {
            this.PolicyList[slug]["content"] = res.data.content;
            // this.PolicyList[slug]["content"] =
            //   "res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content res.data.content";
            console.log(this.PolicyList);
            this.$forceUpdate();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  beforeMount() {
    if (this.PolicyPages) {
      for (const key in this.PolicyPages) {
        this.PolicyList[key] = {
          slug: key,
          title: this.PolicyPages[key],
          content: "",
        };
      }
    }
  },
  mounted(){
      document.body.appendChild(this.$refs.PolicyPagesleModal);
  }
};
</script>
<style  lang='scss'>
.pagefoot {
  margin-top: 50px;
  border-top: 1px solid #e6e6e6;
  padding: 14px 0;
  font-size: 12px;
  color: #737373;
  ul {
    margin: 0 -15px;
    padding: 0;
    li {
      padding: 0 15px;
      white-space: nowrap;
      display: inline-block;
      box-sizing: border-box;
      list-style: none;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .modal {
    padding-right: 0 !important;
    .modal-content {
      border-radius: 8px;
      .modal-header {
        background-color: #fafafa;
        h5 {
          font-size: 16px;
          color: #242424;
        }
      }
      .modal-body {
        max-height: 404px;
        * {
          margin: 0;
          padding: 0;
        }
      }
      .modal-footer {
        button {
          border-radius: 7px;
          font-size: 18px;
          padding: 6px 20px;
        }
      }
    }
  }
  a {
    font-size: 12px;
    color: #128fae;
    text-decoration: none;
  }

  & > a:not(:last-child) {
    margin-right: 20px;
  }
}
@media screen and(min-width: 767px) {
  .modal-dialog {
    max-width: 600px;
  }
}
@media screen and(max-width: 575px) {
  .pagefoot {
    .modal {
      .modal-content {
        .modal-body {
          max-height: 202px;
        }
      }
    }
  }
}
</style>
